// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";
import { useEffect, useState } from "react";
import ApiService from "services/ApiService";
import _ from "lodash";

function TransmissionCards() {
  const [invoiceCount, setInvoiceCount] = useState(0);
  const [invoiceSummary, setInvoiceSummary] = useState(0);

  const fetchDayCardInfo = async () => {
    try {
      const data = await getInvoiceCount();
      setInvoiceCount(data.invoiceCount);
      setInvoiceSummary(data.invoiceSum);
    } catch (error) {
      console.error(error);
    }
  };

  const getInvoiceCount = async () => {
    const response = await ApiService.getData(`/api/v1/invoices/count`);
    return response.data;
  };

  useEffect(() => {
    fetchDayCardInfo();
    setInterval(fetchDayCardInfo, 10 * 60 * 1000);
  }, []);
  return (
    <SoftBox position="relative" zIndex={10} mt={-19} px={{ xs: 1, sm: 0 }}>
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} md={6}>
          <DefaultCounterCard
            count={invoiceCount}
            title={"ΔΙΑΒΙΒΑΣΕΙΣ ΠΑΡΑΣΤΑΤΙΚΩΝ"}
            description="Εντός της ημέρας"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <DefaultCounterCard
            count={invoiceSummary}
            suffix={"€"}
            decimals={2}
            title={"ΣΥΝΟΛΙΚΗ ΑΞΙΑ ΠΑΡΑΣΤΑΤΙΚΩΝ"}
            description="Εντός της ημέρας"
          />
        </Grid>
      </Grid>
    </SoftBox>
  );
}

// Typechecking props for the TransmissionCards
TransmissionCards.propTypes = {
  prices: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TransmissionCards;
